import React from 'react';

const Community = () => (
  <div className="container py-5">
    <h3 className="text-lg text-uppercase font-title text-center mb-4">
      Pin The Look Community Guidelines
    </h3>
  </div>
);

export default Community;
